import { error404Img } from "#web/assets";
import { routeConfig } from "#web/configs/route";
import { i18nLike } from "#web/services/i18nLike";
import { Card, EmptyState, Page } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";

const en = {
  action: "Go back",
  description: "Opps! We couldn't find the page you were looking for.",
  title: "404",
};

export const Error404 = () => {
  const t = i18nLike(en);
  const navigate = useNavigate();

  return (
    <Page>
      <div style={{ height: "500px" }}>
        <Card>
          <EmptyState
            action={{
              content: t("action"),
              onAction: () => {
                navigate(routeConfig["/"], { replace: true });
              },
            }}
            heading={t("title")}
            image={error404Img}
          >
            <p>{t("description")}</p>
          </EmptyState>
        </Card>
      </div>
    </Page>
  );
};
